import type { SVGProps } from "react";

const paths: Record<string, string> = {
  search: "M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm9 16-3.5-3.5",
  panel: "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm10 0v16",
  copy: "M9 9h11v11H9zM5 15V5a1 1 0 0 1 1-1h10",
  link: "M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1",
  menu: "M4 7h16M4 12h16M4 17h16",
  close: "M6 6l12 12M18 6 6 18",
  chevron: "m9 6 6 6-6 6",
  sun: "M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4",
  moon: "M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z",
  monitor: "M4 5h16v10H4zM9 20h6M12 15v5",
  pencil: "M4 20h4L20 8l-4-4L4 16zM15 5l4 4",
  check: "M4 12.5 9 17.5 20 6.5",
  plus: "M12 5v14M5 12h14",
  trash: "M5 7h14M9 7V4.5h6V7M7.5 7l.8 13h7.4l.8-13",
  up: "M12 19V6M6 12l6-6 6 6",
  bookmark: "M6 4h12v17l-6-4.5L6 21z",
  note: "M5 4h9l5 5v11H5zM14 4v5h5",
  highlighter: "M4 20h5l10-10-5-5L4 15zM13 6l5 5",
  play: "M7 4.5 19 12 7 19.5z",
  pause: "M8 5v14M16 5v14",
  mail: "M3 6h18v12H3zM3 6l9 7 9-7",
  down: "M12 5v13M6 12l6 6 6-6",
};

export function Icon({ name, ...rest }: { name: keyof typeof paths } & SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      <path d={paths[name]} />
    </svg>
  );
}
